(function () {

  const EXTRAS_HANDLE = 'adult-get-togethers-extra-guests-time';
  const BASE_KEY      = 'up to 10 people (base price) / no - just we will leave after the art portion';

  let extrasVariants   = null; // loaded on init
  let variantMap       = {};   // key -> { id, priceCents }

  async function loadExtrasVariants() {
    try {
      const res     = await fetch('/products/' + EXTRAS_HANDLE + '.js');
      const product = await res.json();
      extrasVariants = product.variants || [];
      variantMap = {};
      extrasVariants.forEach(v => {
        variantMap[v.title] = {
          id:          v.id,
          priceCents: parseInt(v.price)
        };
      });
    } catch (err) {
      console.error('Adult extras lookup error:', err);
    }
  }

  function extrasKey(participSel, partyAfterSel) {
    return `${participSel.value} / ${partyAfterSel.value}`;
  }

  function getExtrasVariant(key) {
    return variantMap[key] || null;
  }

  function init() {
    const block = document.getElementById('adult-addons-block');
    if (!block) return;

    const participSel    = document.getElementById('adult-participants');
    const partyAfterSel  = document.getElementById('adult-time-after');
    const errorEl        = document.getElementById('adult-error');
    const subtotalBase   = document.getElementById('adult-subtotal-base');
    const extrasRow      = document.getElementById('adult-extras-row');
    const subtotalExtras = document.getElementById('adult-subtotal-extras');
    const subtotalTotal  = document.getElementById('adult-subtotal-total');
    const basePriceCents = parseInt(block.dataset.basePrice) || 0;

    function fmt(cents) {
      return '$' + (cents / 100).toFixed(2);
    }

    function updateUI() {
      const key     = extrasKey(participSel, partyAfterSel);
      const variant = getExtrasVariant(key);
      const extrasCents = (variant && key !== BASE_KEY) ? variant.priceCents : 0;

      subtotalBase.textContent   = fmt(basePriceCents);
      extrasRow.style.display    = extrasCents > 0 ? 'flex' : 'none';
      subtotalExtras.textContent = fmt(extrasCents);
      subtotalTotal.textContent  = fmt(basePriceCents + extrasCents);
    }

    // Load variants then update UI
    loadExtrasVariants().then(updateUI);

    [participSel, partyAfterSel].forEach(el => {
      el.addEventListener('change', updateUI);
    });

    document.addEventListener('submit', async function (e) {
      const form = e.target.closest('form[action="/cart/add"]');
      if (!form) return;

      e.preventDefault();
      e.stopImmediatePropagation();

      errorEl.style.display = 'none';
      errorEl.textContent   = '';

      const baseVariantId = form.querySelector('[name="id"]')?.value;
      if (!baseVariantId) {
        errorEl.textContent = 'Could not determine variant. Please refresh and try again.';
        errorEl.style.display = 'block';
        return;
      }

      const linkedTo = String(baseVariantId);
      const items    = [];

      // 1. Main booking
      items.push({ id: parseInt(baseVariantId), quantity: 1 });

      // 2. Extras add-on — linked to base
      const key = extrasKey(participSel, partyAfterSel);
      if (key !== BASE_KEY) {
        if (!extrasVariants) await loadExtrasVariants();
        const variant = getExtrasVariant(key);
        if (variant) {
          items.push({
            id:         variant.id,
            quantity:   1,
            properties: { '_linked_to': linkedTo }
          });
        } else {
          errorEl.textContent = 'Could not find the selected options. Please refresh and try again.';
          errorEl.style.display = 'block';
          return;
        }
      }

      try {
        const res  = await fetch('/cart/add.js', {
          method:  'POST',
          headers: { 'Content-Type': 'application/json' },
          body:    JSON.stringify({ items })
        });
        const data = await res.json();

        if (!res.ok) {
          errorEl.textContent = data.description || 'There was a problem adding to cart. Please try again.';
          errorEl.style.display = 'block';
          return;
        }

        window.location.href = '/cart';
      } catch (err) {
        errorEl.textContent = 'Network error. Please check your connection and try again.';
        errorEl.style.display = 'block';
      }
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();